import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	releaseNotesButton: {
		id: 'software-releases-version-detail.header.release-notes-button.release-notes-button',
		defaultMessage: 'Release notes',
		description: 'Release notes button label',
	},
});
